'use strict';

var $ = require('../internals/export');

var call = require('../internals/function-call');

var anObject = require('../internals/an-object');

var aCallable = require('../internals/a-callable');

var $TypeError = TypeError; // `Set.prototype.update` method
// https://github.com/tc39/proposal-collection-methods

$({
  target: 'Map',
  proto: true,
  real: true,
  forced: true
}, {
  update: function update(key, callback
  /* , thunk */
  ) {
    var map = anObject(this);
    var get = aCallable(map.get);
    var has = aCallable(map.has);
    var set = aCallable(map.set);
    var length = arguments.length;
    aCallable(callback);
    var isPresentInMap = call(has, map, key);

    if (!isPresentInMap && length < 3) {
      throw $TypeError('Updating absent value');
    }

    var value = isPresentInMap ? call(get, map, key) : aCallable(length > 2 ? arguments[2] : undefined)(key, map);
    call(set, map, key, callback(value, key, map));
    return map;
  }
});